import React, { useEffect } from 'react';
import styles from './AdminModal.module.css';

function AdminModal({ 
  title, 
  children, 
  onClose, 
  onSubmit, 
  submitText = '保存', 
  cancelText = '取消',
  size = 'medium' // small, medium, large
}) {
  // 按ESC键关闭模态框
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  // 阻止背景滚动
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={handleBackdropClick}>
      <div className={`${styles.modalContent} ${styles[size]}`}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>{title}</h2>
          <button 
            className={styles.closeBtn} 
            onClick={onClose}
            type="button"
          >
            ✕
          </button>
        </div>

        <form onSubmit={onSubmit} className={styles.modalForm}>
          <div className={styles.modalBody}>
            {children}
          </div>

          <div className={styles.modalFooter}>
            <button 
              type="button" 
              className={styles.cancelBtn} 
              onClick={onClose}
            >
              {cancelText}
            </button>
            <button 
              type="submit" 
              className={styles.submitBtn}
            >
              {submitText}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AdminModal;
